import PlaceInFlowPages from './PlaceInFlowPages';
import urls from '../../enums/URLs';

const pageName = new Map<string, string>([
  [urls.CustomerDetails, PlaceInFlowPages.CUSTOMER_DETAILS],
  [urls.ChooseYourPlan, PlaceInFlowPages.PAYMENT_PLAN],
  [urls.PaymentDetails, PlaceInFlowPages.PAYMENT_METHOD],
  [urls.Agreement, PlaceInFlowPages.AGREEMENT],
  [urls.Review, PlaceInFlowPages.AUTHORIZATION],
  [urls.Thanks, PlaceInFlowPages.THANK_YOU],
]);

export default pageName;
